export var ReservationConsultationType;
(function (ReservationConsultationType) {
    ReservationConsultationType["CONSULTATION"] = "CONSULTATION";
    ReservationConsultationType["COMPLAINT"] = "COMPLAINT";
})(ReservationConsultationType || (ReservationConsultationType = {}));
